import React, { useEffect } from "react";
import { Field } from "formik";
import Required from "../../../components/Required";
import RadioButtonGroup from "../../../components/RadioButtonGroup";
import RadioButton from "../../../components/RadioButton";
import Popover from "../../../../formik/refactorOut/components/Popper/Popover";
import { popoverLocation } from '../../../../config/Configuration'

const DeliveryMethod = ({ formik, inputClasses, template, config }) => {


    return (
        config.page.form.sections.deliveryMethodSection.active ?
            <div id='deliveryMethodSection' className='form-section'>

                <h2
                    style={template.styles.section}
                    className="section-heading">
                    {template.title}
                </h2>



                <div className='form-fields' id='delivery-method-form-field'>

                    <label style={{ marginBottom: 22 }}>
                        <span style={template.styles.label}>{template.fields.deliveryMethodGroup.label}</span>{" "}
                        <Required value={true} />
                    </label>



                    {template.fields.deliveryMethodGroup.active && <div className="form-group">
                        <RadioButtonGroup
                            id="deliveryMethodGroup"
                            value={formik.values.deliveryMethodGroup}
                            error={formik.errors.deliveryMethodGroup}
                            touched={formik.touched.deliveryMethodGroup}
                            onChange={formik.setFieldValue}
                            onBlur={formik.setFieldTouched}
                        >
                            {template.fields.deliveryMethodGroup.entries.map(option => {
                                return (
                                    <span style={template.styles.list} key={option.key} className="form-check">
                                        <Field
                                            key={option.key}
                                            component={RadioButton}
                                            name="deliveryMethodGroup"
                                            id={"deliveryMethodGroup" + option.key}
                                            value={"deliveryMethodGroup" + option.key}
                                            label={option.value}
                                            config={config}
                                        />
                                    </span>
                                )
                            }
                            )}
                        </RadioButtonGroup>
                        {formik.touched.deliveryMethodGroup &&
                            formik.errors.deliveryMethodGroup ? (
                            <span className="input-error-text">
                                {formik.errors.deliveryMethodGroup}
                            </span>
                        ) : null}
                    </div>}

                </div>
            </div>
            :
            <></>
    );
};

export default DeliveryMethod;

